import { FieldValues } from 'react-hook-form'
import { IFormField } from 'types'
import { TooltipFieldWrapper } from 'components/TooltipFieldWrapper'
import { FieldRenderer } from '../FieldRenderer'

type ControlledFieldProps<T extends FieldValues> = {
  field: IFormField<T>
  isLoading?: boolean
}

export const ControlledField = <T extends FieldValues>({
  field: rawField,
  isLoading
}: ControlledFieldProps<T>) => {
  const field = {
    ...rawField,
    isLoading
  } as IFormField<T>

  return (
    <TooltipFieldWrapper label={field.label} tooltipText={rawField.tooltip}>
      <FieldRenderer field={field} />
    </TooltipFieldWrapper>
  )
}
